import { Box } from '@mui/material'
import ProfileCard from '../ProfileCard/ProfileCard'
import styles from './PartyCards.module.scss'

export default function PartyCards({ partyMembers, onAddOthersClick }) {
	return (
		<Box className={styles.partyCards}>
			<Box className={styles.partyCardsBox}>
				{partyMembers.map((member) => (
					<ProfileCard
						key={member.id}
						label={member.name}
						image={member.image}
					/>
				))}
				<ProfileCard label="+ Add Others" onClick={onAddOthersClick} />
			</Box>
		</Box>
	)
}
